import {
  Context,
  useMakeOrderFactory,
  UseMakeOrderFactoryParams
} from '@vue-storefront/core';
import type { Order } from '@bee-hole/api';
import { useApiError } from '../useApiError';
const factoryParams: UseMakeOrderFactoryParams<Order> = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  make: async (context: Context, { customQuery }) => {
    const res = await context.$xbuy.api.orderPay(customQuery);
    // console.log('## 获取心愿单列表同步回执 ##', res);
    if (res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data;
  }
};

export const useMakeOrder = useMakeOrderFactory<Order>(factoryParams);
